module.exports = __webpack_public_path__ + "img/12.2405c467.webp";